import { Col, Row } from 'antd'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import { RecordType } from 'app/constants/GlobalTypes'
import { retry } from 'app/lib/utils/retry'
import { lazy, Suspense } from 'react'
import * as React from 'react'

type PageType = {
  default: React.ComponentType<{ src: string }>
}

const KDocument = lazy(
  () => retry(() => import('app/components/UI-Elements/DataDisplay/KDocument')) as Promise<PageType>
)

type Props = {
  document: IDocument
}

const Modal: React.FC<Props> = ({ document }) => {
  return (
    <Row>
      <Col xs={24} sm={6} md={16} lg={18}>
        <Suspense fallback={null}>
          <KDocument src={document?.url} />
        </Suspense>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} className="pl-3">
        <KInfo
          recordType={RecordType.document}
          member={{
            created_by: document.created_by,
            created_at: document.created_at
          }}
        />
      </Col>
    </Row>
  )
}

export default Modal
